import React, { Component } from 'react'
import axios from 'axios'
import ls from 'local-storage'
import Select from 'react-select'

export class Financial extends Component {
    constructor(props){     
        super(props);   
        this.state = {
          errors: {},
          finyearlist: [], 
          details:{}
         }  
        this.handleChange = this.handleChange.bind(this);
        this.selecthandleChange = this.selecthandleChange.bind(this);
      }
      componentDidMount() {
        document.title = "CA Details"
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');  
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;   
        if(this.props.children){
            Axios.get(`${process.env.REACT_APP_API_URL}contractor/contractorfinancial/agencyid/`+this.props.children)
          .then(result=>{
            if(result.status === 200){
              this.setState({details:result.data});                      
            }      
          });      
        } 
        Axios.get(`${process.env.REACT_APP_API_URL}master/getfinyear`)
        .then(result=>{
            const options = result.data.map(d => ({
              "value" : d.finacial_year,
              "label" : d.finacial_sort          
            }))    
            this.setState({finyearlist: options})             
        });        
    }  
    async handleChange(event) {
        let details = this.state.details;
        let errors = this.state.errors;
        details[event.target.name] = event.target.value;   
        errors[event.target.name] = '';      
        this.setState({details,errors});       
      } 
      async selecthandleChange(name,e) {
        console.log(e);
        let details = this.state.details;        
        let errors = this.state.errors;
        details[name] = e.value;   
        errors[name] = '';       
        this.setState({details,errors});      
        
      }             
    render() {
        return (
            <div className="box-body">
                <form>
                   <div className="col-md-12">
                        <div className="col-md-6">
						    <div className="form-group required">
                                <label className="control-label">Year</label>
                                <Select 
                                        options={this.state.finyearlist} 
                                        name="startfinyr" 
                                        value={this.state.finyearlist.filter(({value}) => value === this.state.details.startfinyr) || ''} 
                                        onChange={this.selecthandleChange.bind(this,'startfinyr')} 
                                        />
									<span id="errorstartfinyr" className="text-danger"></span>
                            </div>
						</div>					
                        <div className="col-md-6">
						    <div className="form-group required">
                                <label className="control-label">Value of Work on Hand (Rs. Lacs)</label>
									<input className="form-control" type="text" name="valueofworkprevious"  value={this.state.details.valueofworkhand || ''} onChange={this.handleChange} />
									<span id="errorvalueofworkprevious" className="text-danger"></span>
                            </div>
						</div>						 
                    </div>
                    <div className="col-md-12">
                        <div className="col-md-6">
						    <div className="form-group required">
                                <label className="control-label">Value of Work Done (Rs. Lac)</label>
				                 <input className="form-control" type="text" name="valueofworkhand" value={this.state.details.valueofworkhand || ''} onChange={this.handleChange} />
								 <span id="errorvalueofworkhand" className="text-danger"></span>
                            </div>						
                         </div>					
                        <div className="col-md-6">
						    <div className="form-group required">
                                <label className="control-label">Annual Turn Over (Rs. Lacs)</label>
									<input className="form-control" type="text" name="annualturnover" value={this.state.details.annualturnover || ''} onChange={this.handleChange} />
									<span id="errorvannualturnover" className="text-danger"></span>
                            </div>
						</div>						 
                    </div>					
                    <div className="box-footer">
                        <button type="submit" className="btn btn-primary pull-right" name="Update">Save</button>
                    </div>
            </form>
			</div>
        )
    }
}

export default Financial
